import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth';
import { DemoPage } from './pages/DemoPage';
import { AppLayout } from './layout';
import { AgentEditPage } from './pages/AgentEditPage';
import { AgentsPage } from './pages/AgentsPage';
import { AuditPage } from './pages/AuditPage';
import { ConversationDetailPage, ConversationsPage } from './pages/ConversationsPage';
import { HandoffsPage } from './pages/HandoffsPage';
import { KnowledgePage } from './pages/KnowledgePage';
import { LeadDetailPage, LeadsPage } from './pages/LeadsPage';
import { LoginPage } from './pages/LoginPage';
import { MembersPage } from './pages/MembersPage';
import { OverviewPage } from './pages/OverviewPage';
import { SettingsPage } from './pages/SettingsPage';
import { isDemoOrigin } from './agent-sharing';

export function App() {
  const demoBaseUrl =
    typeof import.meta.env.VITE_DEMO_BASE_URL === 'string'
      ? import.meta.env.VITE_DEMO_BASE_URL
      : undefined;
  const supportsShortDemoRoute = isDemoOrigin(
    window.location.origin,
    demoBaseUrl,
  );
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/demo/:publicAgentId" element={<DemoPage />} />
        {supportsShortDemoRoute && <Route path="/:publicAgentId" element={<DemoPage />} />}
        <Route
          element={
            <AuthProvider>
              <Outlet />
            </AuthProvider>
          }
        >
          <Route path="/login" element={<LoginPage />} />
          <Route element={<AppLayout />}>
            <Route index element={<OverviewPage />} />
            <Route path="agents" element={<AgentsPage />} />
            <Route path="agents/:id" element={<AgentEditPage />} />
            <Route path="knowledge" element={<KnowledgePage />} />
            <Route path="conversations" element={<ConversationsPage />} />
            <Route path="conversations/:id" element={<ConversationDetailPage />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="leads/:id" element={<LeadDetailPage />} />
            <Route path="handoffs" element={<HandoffsPage />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="audit" element={<AuditPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
